import { render, staticRenderFns } from "./HeaderExpert.vue?vue&type=template&id=410d7900&"
import script from "./HeaderExpert.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HeaderExpert.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('410d7900')) {
      api.createRecord('410d7900', component.options)
    } else {
      api.reload('410d7900', component.options)
    }
    module.hot.accept("./HeaderExpert.vue?vue&type=template&id=410d7900&", function () {
      api.rerender('410d7900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/HeaderExpert.vue"
export default component.exports